export {
    DOMAIN_TYPE,
    ARCHITECTURE,
    WORKLOAD_DOMAIN_TYPE,
    DEPLOYMENT,
    STORAGE_TYPE,
    CONFIGURATION_STRATEGIES,
} from 'pcs-domain';

export enum SUPERCOLLIDER_EVENT_TYPE {
    CREATE = "CREATE",
    SHARE = "SHARE",
    CLONE = "CLONE",
    DELETE = "DELETE",
    REPORT_DOWNLOAD = "REPORT_DOWNLOAD",
    REPORT_DOWNLOAD_FAILURE = "REPORT_DOWNLOAD_FAILURE",
    LIVEOPTICS_IMPORT_SUCCESS = "LIVEOPTICS_IMPORT_SUCCESS",
    LIVEOPTICS_IMPORT_FAILURE = "LIVEOPTICS_IMPORT_FAILURE",
    RVTOOLS_IMPORT_SUCCESS = "RVTOOLS_IMPORT_SUCCESS",
    RVTOOLS_IMPORT_FAILURE = "RVTOOLS_IMPORT_FAILURE",
    RECOMMENDATION_DONE = "RECOMMENDATION_DONE",
    RECOMMENDATION_CSAT = "RECOMMENDATION_CSAT",
    QUICK_SIZER_OPEN = "QUICK_SIZER_OPEN",
    QUICK_SIZER_CALCULATE = "QUICK_SIZER_CALCULATE",
    QUICK_SIZER_PDF_EXPORT = "QUICK_SIZER_PDF_EXPORT",
    QUICK_SIZER_PDF_EXPORT_FAILURE = "QUICK_SIZER_PDF_EXPORT_FAILURE"
}
